import { EventEmitter } from 'events';

export default class SingletonEventEmitterClass extends EventEmitter {
  protected static __instance: any;
  protected static __new: boolean = true;

  constructor() {
    super();
    const constructor = this.constructor as SingletonConstructor;
    if (constructor.__instance) {
      constructor.__new = false;
      return constructor.__instance;
    } else {
      constructor.__instance = this;
      return this;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/SingletonEventEmitterClass.ts